import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页", end: true },
  { to: "/category/movie", label: "电影" },
  { to: "/category/tv", label: "电视剧" },
  { to: "/category/short", label: "短片" },
  { to: "/about", label: "关于我们" },
  { to: "/contact", label: "联系我们" },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    setMenuOpen(false);
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
  };

  return (
    <header className="sticky top-0 z-50 border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="mx-auto flex h-16 items-center gap-4 px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-film-line text-xl"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-base font-bold text-primary-700">
              伦理片在线观看
            </span>
            <span className="mt-0.5 text-[10px] tracking-widest text-secondary-500">
              ETHICS FILM
            </span>
          </span>
        </Link>

        <nav className="ml-4 hidden items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `whitespace-nowrap rounded-md px-3 py-2 text-sm transition-colors ${
                  isActive
                    ? "bg-primary-50 font-medium text-primary-700"
                    : "text-foreground-700 hover:bg-background-100 hover:text-primary-700"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <form
          onSubmit={submitSearch}
          className="ml-auto hidden items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3 py-1.5 md:flex"
        >
          <i className="ri-search-line text-secondary-500"></i>
          <input
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="搜索影片、导演、题材"
            className="w-40 bg-transparent text-sm text-foreground-900 outline-none placeholder:text-secondary-400 lg:w-52"
          />
          <button
            type="submit"
            className="whitespace-nowrap rounded-md bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            搜索
          </button>
        </form>

        <Link
          to="/search"
          className="ml-auto flex h-9 w-9 items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 md:hidden"
          aria-label="搜索"
        >
          <i className="ri-search-line text-lg"></i>
        </Link>

        <button
          type="button"
          onClick={() => setMenuOpen((v) => !v)}
          className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 lg:hidden"
          aria-label="菜单"
        >
          <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="lg:hidden">
          <div className="mx-auto flex flex-col gap-1 border-t border-background-200 px-4 py-3">
            <form
              onSubmit={submitSearch}
              className="mb-2 flex items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3 py-2"
            >
              <i className="ri-search-line text-secondary-500"></i>
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索影片、导演、题材"
                className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-secondary-400"
              />
            </form>
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `rounded-md px-3 py-2.5 text-sm transition-colors ${
                    isActive
                      ? "bg-primary-50 font-medium text-primary-700"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}